import { render, staticRenderFns } from "./ActiveButtonWithArrow.vue?vue&type=template&id=b7f58c6c&scoped=true&"
import script from "./ActiveButtonWithArrow.vue?vue&type=script&lang=js&"
export * from "./ActiveButtonWithArrow.vue?vue&type=script&lang=js&"
import style0 from "./ActiveButtonWithArrow.vue?vue&type=style&index=0&id=b7f58c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f58c6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
